var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,5.8c-3.4,0-6.2,2.7-6.2,6.2s2.7,6.2,6.2,6.2c3.4,0,6.2-2.7,6.2-6.2S15.4,5.8,12,5.8z M12,16 c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4C16,14.2,14.2,16,12,16z M19.8,5.6c0,0.8-0.6,1.4-1.4,1.4C17.6,7,17,6.4,17,5.6 s0.6-1.4,1.4-1.4C19.2,4.2,19.8,4.8,19.8,5.6z M23.9,7.1c-0.1-1.9-0.5-3.6-1.9-5c-1.4-1.4-3.1-1.8-5-1.9C15,0,9,0,7.1,0.1 C5.1,0.2,3.4,0.6,2,2C0.6,3.4,0.2,5.1,0.1,7C0,9,0,15,0.1,16.9c0.1,1.9,0.5,3.6,1.9,5c1.4,1.4,3.1,1.8,5,1.9c2,0.1,7.9,0.1,9.9,0 c1.9-0.1,3.6-0.5,5-1.9c1.4-1.4,1.8-3.1,1.9-5C24,15,24,9,23.9,7.1z M21.4,19.1c-0.4,1-1.2,1.9-2.3,2.3c-1.6,0.6-5.3,0.5-7.1,0.5 S6.5,22,4.9,21.4c-1-0.4-1.9-1.2-2.3-2.3C2,17.5,2.2,13.7,2.2,12S2,6.5,2.6,4.9c0.4-1,1.2-1.9,2.3-2.3C6.5,2,10.3,2.2,12,2.2 s5.5-0.1,7.1,0.5c1,0.4,1.9,1.2,2.3,2.3c0.6,1.6,0.5,5.3,0.5,7.1S22,17.5,21.4,19.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramFooter);
export default __webpack_public_path__ + "static/media/instagram_footer.cf9198bf35d1e4881cbba525b5f49f0a.svg";
export { ForwardRef as ReactComponent };